import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const DispenserKpiStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
`

export const DispenserName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`

export const DispenserNameText = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const DispenserNoteText = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.status.danger.fg};
`

export const DispenserCellText = styled.span<{ $tone?: 'warning' | 'danger' }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) => ($tone ? tokens.status[$tone].fg : tokens.text.secondary)};
`
